module.exports = __webpack_public_path__ + "static/img/not-found2.84c57e0c.jpeg";